import React from 'react'
import { PostConnectStepFrame } from '../PostConnectStepFrame'
import { OnboardingStepFinished } from '../../Onboarding/OnboardingStepFinished/OnboardingStepFinished'
import { POST_CONNECT_COPIES } from '../../copies/onboardingCopies'

export interface ZoomSuccessStepProps {
  onContinue: () => void
  onBack?: () => void
}

export const ZoomSuccessStep: React.FC<ZoomSuccessStepProps> = ({ onContinue, onBack }) => (
  <PostConnectStepFrame onAdvance={onContinue} onBack={onBack} nextLabel='Done'>
    <OnboardingStepFinished
      title='Zoom set up successfully'
      bullets={POST_CONNECT_COPIES['zoom-success'].bullets}
      links={[{ label: 'Set up custom Auto-join rules', to: '/account/profile-settings/meeting-assistant' }]}
    />
  </PostConnectStepFrame>
)
